import firebase, { institutesRef } from "./firebaseconn";

export const getCommentsByReview = async function(instituteID, reviewID) {
  try {
    const snapshot = await institutesRef
      .doc(instituteID)
      .collection("reviews")
      .doc(reviewID)
      .collection("comments")
      .orderBy("createdAt")
      .get();
    return snapshot.docs.map(review => ({ id: review.id, ...review.data() }));
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createComment = async function(
  data,
  currentUser,
  instituteID,
  reviewID
) {
  data.createdAt = firebase.firestore.FieldValue.serverTimestamp();
  data.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
  data.userEmail = currentUser.email;
  data.userName = currentUser.userName;
  //   data.reviewID = review.id;

  data.active = true;

  try {
    return await institutesRef
      .doc(instituteID)
      .collection("reviews")
      .doc(reviewID)
      .collection("comments")
      .add(data);
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updateComment = async function(id, data, instituteID, reviewID) {
  data.updatedAt = firebase.firestore.FieldValue.serverTimestamp();

  try {
    await institutesRef
      .doc(instituteID)
      .collection("reviews")
      .doc(reviewID)
      .collection("comments")
      .doc(id)
      .update(data);
    return true;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const deleteComment = async function(id, data, instituteID, reviewID) {
  data.deletedAt = firebase.firestore.FieldValue.serverTimestamp();
  data.active = false;

  try {
    await institutesRef
      .doc(instituteID)
      .collection("reviews")
      .doc(reviewID)
      .collection("comments")
      .doc(id)
      .update(data);
    return true;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
